import HTMLReactParser from 'html-react-parser';
import React from 'react';
import { cn } from '../../utils';

export interface IProductListHeadingProps {
  heading: string;
  subHeading?: string;
  className?: string;
}
const ProductListHeading = ({
  heading,
  subHeading,
  className,
}: IProductListHeadingProps) => {
  return (
    <h2
      className={cn(
        'font-playfairdisplay text-left leading-10 text-brand-secondary text-2xl xl:text-3xl font-[900] my-2 mx-5 xl:mx-0 xl:my-7',
        className,
      )}
    >
      {HTMLReactParser(heading)}
      {subHeading ? (
        <p
          className={`font-playfairdisplay ${
            subHeading === '** AVAILABLE TO SHIP FROM 14th OCTOBER 2024 **'
              ? 'text-black font-bold text-2xl'
              : 'text-brand-primary'
          }`}
        >
          {HTMLReactParser(subHeading)}
        </p>
      ) : null}
    </h2>
  );
};

export default ProductListHeading;
